import { render, staticRenderFns } from "./ActionHandlePortingManually.vue?vue&type=template&id=630e29dc&scoped=true&"
import script from "./ActionHandlePortingManually.vue?vue&type=script&lang=js&"
export * from "./ActionHandlePortingManually.vue?vue&type=script&lang=js&"
import style0 from "./ActionHandlePortingManually.vue?vue&type=style&index=0&id=630e29dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e29dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VRadio,VRadioGroup,VSelect,VTextField,VTextarea})
